import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";
import moment from "moment";

function UserPlanModal({
  open = false,
  onCancel = () => {},
  onSuccess = () => {},
}) {
  const [plans, setPlans] = useState([]);

  const fetchPlans = async () => {
    const res = await apiRequest({
      path: apiPaths.subscriptionPlans + "?show_all=true",
    });
    if (!res.error) {
      setPlans(res.results);
    } else {
      message.error(res.error_description);
    }
  };

  const handleAddUserPlan = async (values) => {
    let fullName = values.full_name.split(" ");
    delete values.full_name;
    values.plan = values.plan.value;
    const data = {
      ...values,
      user_fname: fullName[0],
      user_lname: fullName.slice(1).join(" "),
    };
    const res = await apiRequest({
      path: apiPaths.userPlans,
      method: "POST",
      data,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    message.success("Added plan to user");
    onSuccess(res);
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return (
    <Modal
      title={"Add Plan to User"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form layout="vertical" onFinish={handleAddUserPlan}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Plan (Validity)"
              name={"plan"}
              rules={[
                {
                  required: true,
                  message: `Please select plan!`,
                },
              ]}
            >
              <Select
                placeholder={"Select plan"}
                style={{ width: 280 }}
                labelInValue={true}
              >
                {plans.map((item, index) =>
                  item.validity ? (
                    <Select.Option key={index + "o"} value={item.id}>
                      {item.name + ` (${item.validity} days)`}
                    </Select.Option>
                  ) : null
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Plan Start Date"
              name="start_time"
              rules={[
                {
                  required: true,
                  message: "Please select Plan Start Date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "60%" }}
                placeholder="Select Start Date"
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="User Full Name"
              name="full_name"
              rules={[
                {
                  required: true,
                  message: "Please enter user name",
                },
              ]}
            >
              <Input placeholder="Eg: Jhon Dar" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="User Email"
              name="user_email"
              rules={[
                {
                  required: true,
                  message: "Please enter user email",
                },
              ]}
            >
              <Input placeholder="Eg: someone@gmail.com" type={"email"} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="User Phone Number"
              name="user_mobile"
              rules={[
                {
                  required: true,
                  message: "Please enter user phone",
                },
              ]}
            >
              <Input placeholder="Eg: 9090999089" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default UserPlanModal;
